module.exports = __webpack_public_path__ + "media/images/icons/outlined/cloud-8cf2d922dadbbe403664acff82aaceda.svg";